import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import LincantoDellaLuce from "./sections/LincantoDellaLuce";
import IlLaboratorioMobile from "./sections/IlLaboratorioMobile";
import LAlchimiaDellaStampa from "./sections/LAlchimiaDellaStampa";
import EssenzeDaEvento from "./sections/EssenzeDaEvento";
import FragmentsOfHistory from "./sections/FragmentsOfHistory";
import VociDalPassatoRecente from "./sections/VociDalPassatoRecente";
import CatturaLattimo from "./sections/CatturaLattimo";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <LincantoDellaLuce />
      <IlLaboratorioMobile />
      <LAlchimiaDellaStampa />
      <EssenzeDaEvento />
      <FragmentsOfHistory />
      <VociDalPassatoRecente />
      <CatturaLattimo />
      <Footer />
    </div>;
}